export default __webpack_public_path__ + "static/media/person.163d185c.svg";